import { Component, Input } from '@angular/core';
import { TuiTable } from '@taiga-ui/addon-table';
import { InterventionRowComponent } from '../intervention-row/intervention-row.component';
import { Intervention } from '../../models/intervention';

@Component({
  selector: 'app-intervention-list',
  standalone: true,
  imports: [
    TuiTable,
    InterventionRowComponent
  ],
  templateUrl: './intervention-list.component.html',
  styleUrl: './intervention-list.component.scss'
})
export class InterventionListComponent {
  @Input() interventionList: Intervention[] = [];
  @Input() format: string | undefined;
}
